export default "__VITE_ASSET__B5MV4Xix__"